import { render, staticRenderFns } from "./ModalResources.vue?vue&type=template&id=7db15148"
import script from "./ModalResources.vue?vue&type=script&lang=js"
export * from "./ModalResources.vue?vue&type=script&lang=js"
import style0 from "./ModalResources.vue?vue&type=style&index=0&id=7db15148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports